export default __webpack_public_path__ + "static/media/MARCA_UNIVERSIDAD_BLANCO_TRANS_1.4dc1fc8f.png";